import { LARGEURS_ANALYSE, LIBELLES_ANALYSE } from '../../utils/aruco';

/**
 * Le choix de la taille de l'image analysée, ouvert par la pastille du
 * bandeau (2026-09-22). « Auto » = le réglage automatique du scanner (départ
 * 720p, un cran vers le bas quand l'analyse dépasse 150 ms, un cran vers le
 * haut sous 60 ms), le cas de tout le monde ; une taille = forcée jusqu'à la
 * prochaine ouverture de la page. Plus petite : plus rapide, mais capte moins
 * loin (à 3 m, 1080p lit encore une carte à 4,5 m, 720p à 3 m, 540p à 2,5 m
 * environ). Remplace le panneau de mesures du banc d'essai des 21-22/09,
 * retiré une fois la règle calée.
 */
const style = (actif) => (actif
  ? { background: '#fff', color: '#0A1F3D' }
  : { background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.25)', color: '#fff' });

const ChoixTaille = ({ largeurForcee, largeurAnalyse, onChoisir }) => {
  const auto = largeurForcee == null;
  const tailleAuto = auto ? LIBELLES_ANALYSE[largeurAnalyse] : null;
  return (
    <div
      className="absolute left-3 z-[5] w-[230px] rounded-2xl px-3.5 py-3 text-white"
      style={{ top: 104, background: 'rgba(0,0,0,.82)', border: '1px solid rgba(255,255,255,.18)', fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}
      data-testid="choix-taille"
      role="group"
      aria-label="Taille de l'image analysée"
    >
      <p className="text-[11px] uppercase tracking-wider text-white/55 mb-2">Image analysée</p>
      <button
        type="button"
        onClick={() => onChoisir(null)}
        aria-pressed={auto}
        className="w-full py-1.5 rounded-lg text-[12px] font-bold mb-1.5 transition"
        style={style(auto)}
      >
        {tailleAuto ? `Auto · ${tailleAuto}` : 'Auto'}
      </button>
      <div className="flex gap-1.5">
        {LARGEURS_ANALYSE.map((largeur) => {
          const actif = largeur === largeurForcee;
          return (
            <button
              key={largeur}
              type="button"
              onClick={() => onChoisir(largeur)}
              aria-pressed={actif}
              className="flex-1 py-1.5 rounded-lg text-[12px] font-bold transition"
              style={style(actif)}
            >
              {LIBELLES_ANALYSE[largeur] || largeur}
            </button>
          );
        })}
      </div>
      <p className="text-[11px] mt-2 leading-snug" style={{ color: 'rgba(255,255,255,.7)' }}>
        Plus petite : plus rapide, mais capte moins loin.
      </p>
    </div>
  );
};

export default ChoixTaille;
